import tools from '../../util/tools'
import debugHelper from '../../util/debug'
import axios from 'axios'
import { URLS } from '../../util/urls'
import i18n from '../../lang/index'


const displayName = '数络密盾'

const state = {
	langType: 'zh',
	displayName: displayName,
	/**                                                                                                                                  
	 * 版本信息                                                                                                                                  
	 * APP APK更新版本号与H5热更新版本号要区分开，若只是H5更新，APK包检测版本不应该是v0.1.2.85，而是v0.1.1。                                                                                                                                  
	 * 例：0.1.2.85                                                                                                                                
	 *    0 是大版本号、1 是小版本号、2 是APK更新号（APK发布时，此值加1）、85 是H5的更新号，                                                                                                                                
	 */
	version: '1.0.24.58',
	/**                                                                                                                                  
	 * 开发商信息                                                                                                                                  
	 */
	developer: i18n.t('杭州数络信息技术有限公司'),
	/**                                                                                                                                  
	 * 标题栏、应用头                                                                                                                                  
	 */
	toolBar: {
		/**                                                                                                                                  
		 * 标题(不可选择)                                                                                                                                  
		 */
		title: {
			title: displayName,
			icon: '', // 图片
			visible: true
		},
		/**                                                                                                                                
		* 标题颜色(不可选择)                                                                                                                                
		*/
		titleStyle: {
			value: '#FFF'
		},
		/**                                                                                                                                  
		 * 标题列表, 可选择                                                                                                                                  
		 */
		titleList: {
			/**                                                                                                                                  
			 * 列表                                                                                                                                  
			 */
			list: [],
			visible: false,
			/**                                                                                                                                  
			 * 修改事件                                                                                                                                  
			 */
			change: null,
			/**                                                                                                                                  
			 * 当前值                                                                                                                                  
			 */
			curValue: ''
		},
		toolbarDisabled: false,
		/**                                                                                                                                  
		 * 是否禁用左侧按钮(默认返回键)                                                                                                                                  
		 */
		backDisabled: true,
		/**                                                                                                                                  
		 * 返回键返回的特殊路由                                                                                                                              
		 */
		backSpecialRoute: '',
		/**                                                                                                                                  
		 * 返回键返回的特定参数                                                                                                                              
		 */
		backSpecialParams: null,
		/**                                                                                                                                  
		 * 主页路由                                                                                                                              
		 */
		homePageRoute: '',
		/**                                                                                                                                  
		 * 左侧按钮图标(默认返回键)                                                                                                                                  
		 */
		backIcon: '',
		/**                                                                                                                                  
		 * 是否禁用右侧菜单                                                                                                                                  
		 */
		menuDisabled: true,
		/**                                                                                                                                  
		 * 右侧菜单图标                                                                                                                                  
		 */
		menuIcon: '',
		/**                                                                                                                                  
		 * 右侧菜单, 与SingleButton不能共存                                                                                                                                  
		 */
		menuItems: [
			{
				title: '',
				func: ''
			},
			{
				title: '',
				func: ''
			}
		],
		/**                                                                                                                                  
		 * 是否禁用右侧按钮                                                                                                                                  
		 */
		singleButtonDisabled: true,
		/**                                                                                                                                  
		 * 右侧按钮信息                                                                                                                                  
		 */
		singleButton: {
			title: '',
			func: '',
			color: 'black'
		}
	},
	/**                                                                                                                                  
	 * 底部的导航栏                                                                                                                                  
	 */
	bottomNav: {
		/**                                                                                                                                  
		 * 当前激活的按钮, 必须是当前激活按钮的字符串                                                                                                                                  
		 */
		activeBtn: '',
		visible: false,
		buttons: new Array()
	},
	/**                                                                                                                                  
	 * 底部操作按钮                                                                                                                                  
	 */
	bottomBtn: {
		visible: false,
		buttons: new Array()
	},
	/**                                                                                                                                  
	 * 原定消息输入位置, 弃用                                                                                                                                  
	 */
	msgInput: {
		visible: false
	},
	/**                                                                                                                                  
	 * 控制整个app内容显示区域的大小                                                                                                                                  
	 */
	content: {
		height: 'calc(100vh - 48px - 4rem)',
		innerHeight: '100vh',
		scrollTop: '0',
		bottomHeight: '56px'
	},
	/**                                                                                                                                  
	 * 控制该变量用来显示消息内容                                                                                                                                  
	 */
	snackbar: {
		visible: false,
		color: '', // ['success', 'info', 'error', 'cyan darken-2']"                                                                                                                                  
		mode: '',
		x: '',
		y: 'top',
		timeout: 3000,
		text: 'Hello, I\'m a snackbar'
	},
	/**                                                                                                                                  
	 * 控制该变量来同步说明文件访问权限申请的使用目的
	 */
	requestStorage: {
		visible: false,
		callback: null,
	},
	/**                                                                                                                                  
	 * app所启用的平台,用来限定显示内容根操作                                                                                                                                  
	 */
	platform: null,
	/**                                                                                                                                  
	 * 是不是由密码登陆                                                                                                                                  
	 */
	isPwd: true,
	/**                                                                                                                                  
	 * 百度语音接口                                                                                                                                  
	 */
	ttsToken: {
		data: {
			access_token: ''
		}
		/*{                                                                                                                                            
		"data": {                                                                                                                                            
				"access_token": "24.869815498f262ef395f8e51068269163.2592000.1550997002.282335-14923304",                                                                                                                                            
				"expires_in": 2592000,                                                                                                                                            
				"refresh_token": "25.2b72d42dc6fa2c35a66db20b206c5a0d.315360000.1863765002.282335-14923304",                                                                                                                                            
				"scope": "audio_voice_assistant_get audio_tts_post public brain_all_scope wise_adapt lebo_resource_base lightservice_public hetu_basic lightcms_map_poi kaidian_kaidian ApsMisTest_Test权限 vis-classify_flower lpq_开放 cop_helloScope ApsMis_fangdi_permission smartapp_snsapi_base iop_autocar oauth_tp_app smartapp_smart_game_openapi oauth_sessionkey smartapp_swanid_verify smartapp_opensource_openapi",                                                                                                                                            
				"session_key": "9mzdA5x5G4omMVN+/luqJHrntOXq92ypLjW+XpXHj+eszcVy/RJJGyYXPilJsm9C5nIq83pD+DIso5Tn7MDYXLJN8I+IQg==",                                                                                                                                            
				"session_secret": "ec4e162d596a0160650184b7c2bb5125"                                                                                                                                            
		},                                                                                                                                            
		"status": 200                                                                                                                                            
} */
	},
	/**                                                                                                                                  
	 * 定时器,现在是一个(用来获取未读消息), 以后需要改成一个列表(多个定时器),                                                                                                                                  
	 */
	timer: 0
}
const getters = {
	getLanguage: (state, getters, rootState) => {
		return state.langType
	},

	displayName: state => state.displayName,
	platform: state => state.platform,
	/**                                                                                                                                  
	 * 获取APP开发商信息                                                                                                                                  
	 */
	getDeveloper: (state, getters, rootState) => {
		return state.developer
	},
	getTitle: (state, getters, rootState) => {
		return state.toolBar.title.title
	},
	getTitleStyle: (state, getters, rootState) => {
		return state.toolBar.titleStyle.value
	},
	getTitleList: (state, getters, rootState) => {
		return state.toolBar.titleList
	},
	getTitleInfo: (state, getters, rootState) => {
		return state.toolBar.title
	},
	getBottomNavVisible: (state, getters, rootState) => {
		return state.bottomNav.visible
	},
	getBottomBtnVisible: (state, getters, rootState) => {
		return state.bottomBtn.visible
	},
	getToolbarDisabled: (state, getters, rootState) => {
		return state.toolBar.toolbarDisabled
	},
	getBackDisabled: (state, getters, rootState) => {
		return state.toolBar.backDisabled
	},
	getBackSpecialRoute: (state, getters, rootState) => {
		return state.toolBar.backSpecialRoute
	},
	getBackSpecialParams: (state, getters, rootState) => {
		return state.toolBar.backSpecialParams
	},
	getHomePageRoute: (state, getters, rootState) => {
		return state.toolBar.homePageRoute
	},
	getBackIcon: (state, getters, rootState) => {
		return state.toolBar.backIcon
	},
	getSingleButtonDisabled: (state, getters, rootState) => {
		return state.toolBar.singleButtonDisabled
	},
	getSingleButton: (state, getters, rootState) => {
		return state.toolBar.singleButton
	},
	getMenuDisabled: (state, getters, rootState) => {
		return state.toolBar.menuDisabled
	},
	getMenuIcon: (state, getters, rootState) => {
		return state.toolBar.menuIcon
	},
	getMenuItems: (state, getters, rootState) => {
		return state.toolBar.menuItems
	},
	getPlatform: (state, getters, rootState) => {
		return state.platform
	},
	getBottomNavButtons: (state, getters, rootState) => {
		return state.bottomNav.buttons
	},
	getMsgInputVisible: (state, getters, rootState) => {
		return state.msgInput.visible
	},
	getContentHeight: (state, getters, rootState) => {
		return state.content.height
	},
	getContentInnerHeight: (state, getters, rootState) => {
		return state.content.innerHeight
	},
	getContentBottomHeight: (state, getters, rootState) => {
		return state.content.bottomHeight
	},
	getBottomActiveBtn: (state, getters, rootState) => {
		return state.bottomNav.activeBtn
	},
	getBottomBtn: (state, getters, rootState) => {
		return state.bottomBtn.buttons
	},
	getSnackBar: (state, getters, rootState) => {
		return state.snackbar
	},
	getRequestStorage: (state, getters, rootState) => {
		return state.requestStorage
	},
	getIsPwd: (state, getters, rootState) => {
		return state.isPwd
	},
	getLocalVersion: (state, getters, rootState) => {
		return state.version
	},
	getScrollTop: (state, getters, rootState) => {
		return state.content.scrollTop
	},
	getTimer: (state, getters, rootState) => {
		return state.timer
	},
	getTTSToken: (state, getters, rootState) => {
		return state.ttsToken.data.access_token
	}
}
const actions = {
	setLanguage: ({ commit }, langType) => {
		commit('SetLanguage', { value: langType })
	},
	setTitle: ({ commit }, title) => {
		commit('SetTitle', { value: title })
	},
	setTitleAndIcon: ({ commit }, titleInfo) => {
		commit('SetTitleAndIcon', { value: titleInfo })
	},
	setTitleStyle: ({ commit }, titleStyle) => {
		commit('SetTitleStyle', { value: titleStyle })
	},
	setTitleList: ({ commit }, titleList) => {
		commit('setTitleList', titleList)
	},
	setTitleVisible: ({ commit }, visible) => {
		commit('SetTitleVisible', visible)
	},
	setBottomNavVisible: ({ commit }, visible) => {
		commit('SetBottomNavVisible', { value: visible })
	},
	setBottomBtnVisible: ({ commit }, visible) => {
		commit('SetBottomBtnVisible', { value: visible })
	},
	setBottomBtnLoading: ({ commit }, value) => {
		commit('setBottomBtnLoading', value)
	},
	setToolbarDisabled: ({ commit }, disabled) => {
		commit('SetToolbarDisabled', { value: disabled })
	},
	setBackDisabled: ({ commit }, disabled) => {
		commit('SetBackDisabled', { value: disabled })
	},
	setBackSpecialRoute: ({ commit }, backSpecialRoute) => {
		commit('SetBackSpecialRoute', { value: backSpecialRoute })
	},
	setBackSpecialParams: ({ commit }, backSpecialParams) => {
		commit('SetBackSpecialParams', { value: backSpecialParams })
	},
	setHomePageRoute: ({ commit }, homePageRoute) => {
		commit('SetHomePageRoute', { value: homePageRoute })
	},
	setBackIcon: ({ commit }, backIcon) => {
		commit('SetBackIcon', { value: backIcon })
	},
	setSingleButtonDisabled: ({ commit }, disabled) => {
		commit('SetSingleButtonDisabled', { value: disabled })
	},
	setSingleButton: ({ commit }, singleButton) => {
		commit('SetSingleButton', { value: singleButton })
	},
	setMenuDisabled: ({ commit }, disabled) => {
		commit('SetMenuDisabled', { value: disabled })
	},
	setMenuIcon: ({ commit }, backIcon) => {
		commit('SetMenuIcon', { value: backIcon })
	},
	setPlatform: ({ commit }, platform) => {
		commit('SetPlatform', { value: platform })
	},
	setMenuItems: ({ commit }, buttons) => {
		commit('SetMenuItems', { value: buttons })
	},
	fetchTTSToken: ({ commit }, params) => {
		return new Promise((resolve, reject) => {
			axios({
				method: 'get',
				url: URLS.FETCH_TTS_TOKEN,
				headers: {
					'Content-Type': 'application/json',
					...params.authorization
				}
			})
				.then(resp => {
					commit('setTTSToken', {
						value: resp.data
					})
					resolve()
				})
				.catch(err => {
					// commit("setLoginFailure", {                                                                                                                                  
					//   value: err                                                                                                                                  
					// });                                                                                                                                  
					err.type = 'error'
					err.prefix = 'app:'
					tools.showTips(params.vm, err)
					reject()
					return
				})
		})
	},
	setTimer: ({ commit }, params) => {
		commit('setTimer', params)
	}
}
const mutations = {
	setTimer: (state, payload) => {
		state.timer = payload
	},
	SetLanguage: (state, payload) => {
		console.log('调试代码')
		state.langType = payload.value
	},
	SetTitle: (state, payload) => {
		console.log('调试代码')
		state.toolBar.title.title = payload.value
		state.toolBar.title.icon = ''
	},
	SetTitleAndIcon: (state, payload) => {
		state.toolBar.title.title = payload.value.title
		state.toolBar.title.icon = payload.value.icon
	},
	SetTitleStyle: (state, payload) => {
		state.toolBar.titleStyle.value = payload.value
	},
	setTitleList: (state, payload) => {
		console.log('调试代码')
		debugHelper.log('setTitleList')
		debugHelper.log(payload)
		state.toolBar.titleList.list = payload.list.slice(0)
		state.toolBar.titleList.listIcon = payload.listIcon.slice(0)
		state.toolBar.titleList.visible = payload.visible
		state.toolBar.titleList.change = payload.change
		state.toolBar.titleList.curValue = payload.curValue
		state.toolBar.titleList.curIcon = payload.curIcon
		debugHelper.log(state.toolBar.titleList.list)
	},
	SetTitleVisible: (state, payload) => {
		state.toolBar.title.visible = payload
	},
	SetBottomNavVisible: (state, payload) => {
		state.bottomNav.visible = payload.value
	},
	SetToolbarDisabled: (state, payload) => {
		state.toolBar.toolbarDisabled = payload.value
	},
	SetBackDisabled: (state, payload) => {
		state.toolBar.backDisabled = payload.value
		state.toolBar.backSpecialRoute = '' // 置特殊路由信息为空                                                                                                                               
	},
	SetBackSpecialRoute: (state, payload) => {
		state.toolBar.backSpecialRoute = payload.value
	},
	SetBackSpecialParams: (state, payload) => {
		console.log('调试代码')
		state.toolBar.backSpecialParams = payload.value
	},
	SetHomePageRoute: (state, payload) => {
		state.toolBar.homePageRoute = payload.value
	},
	SetBackIcon: (state, payload) => {
		state.toolBar.backIcon = payload.value
	},
	SetSingleButtonDisabled: (state, payload) => {
		state.toolBar.singleButtonDisabled = payload.value
	},
	SetSingleButton: (state, payload) => {
		state.toolBar.singleButton = payload.value
	},
	SetMenuDisabled: (state, payload) => {
		state.toolBar.menuDisabled = payload.value
	},
	SetMenuIcon: (state, payload) => {
		state.toolBar.menuIcon = payload.value
	},
	SetMenuItems: (state, payload) => {
		state.toolBar.menuItems = payload.value
	},
	SetPlatform: (state, payload) => {
		state.platform = payload.value
	},
	SetBottomBtnVisible: (state, payload) => {
		state.bottomBtn.visible = payload.value
	},
	setBottomNavButtons: (state, payload) => {
		state.bottomNav.buttons = payload.value
	},
	setMsgInputVisible: (state, payload) => {
		//暂时用不到消息输入框                                                                                                                                  
		state.msgInput.visible = false
		//state.msgInput.visible = payload.value                                                                                                                                  
	},
	setContentHeight: (state, payload) => {
		//由于用不到消息输入框, 所以界面要固定                                                                                                                                  
		state.content.height = payload.value
	},
	setContentInnerHeight: (state, payload) => {
		//由于用不到消息输入框, 所以界面要固定                                                                                                                                  
		state.content.innerHeight = payload.value
	},
	setContentBottomHeight: (state, payload) => {
		state.content.bottomHeight = payload.value
	},
	setScrollTop: (state, payload) => {
		state.content.scrollTop = payload.value
	},
	setBottomActiveBtn: (state, payload) => {
		state.bottomNav.activeBtn = payload.value
	},
	setBottomBtn: (state, payload) => {
		// 设置底部按钮前需要清空底部按钮                                                                                                                                  
		state.bottomBtn.buttons.splice(0, state.bottomBtn.buttons.length)
		payload.value.forEach(button => {
			state.bottomBtn.buttons.push(button)
		})
	},
	setBottomBtnLoading: (state, payload) => {
		state.bottomBtn.buttons[payload.index].disabled = payload.flag
		state.bottomBtn.buttons[payload.index].loading = payload.flag
	},
	setSnackBar: (state, payload) => {
		for (var tmp in payload.value) {
			state.snackbar[tmp] = payload.value[tmp]
		}
	},
	setRequestStorage: (state, payload) => {
		for (var tmp in payload.value) {
			state.requestStorage[tmp] = payload.value[tmp]
		}
	},
	setIsPwd: (state, payload) => {
		state.isPwd = payload.value
	},
	setMessageTips: (state, payload) => {
		state.bottomNav.buttons.forEach(bottom => {
			if (bottom.name == '消息') {
				if (payload.value > 99) {
					payload.value = '...'
				}
				bottom.tips = payload.value
			}
		})
	},
	setTaskTips: (state, payload) => {
		console.log('调试代码')
		state.bottomNav.buttons.forEach(bottom => {
			if (bottom.name == '工作') {
				if (payload.value > 99) {
					payload.value = '...'
				}
				bottom.tips = payload.value
			}
		})
	},
	setTTSToken: (state, payload) => {
		state.ttsToken = payload.value
	},
}
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}                                                                                                                                  
